import { render, staticRenderFns } from "./appKiaDnw.vue?vue&type=template&id=45c041a0&scoped=true"
var script = {}
import style0 from "./appKiaDnw.vue?vue&type=style&index=0&id=45c041a0&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45c041a0",
  null
  
)

export default component.exports